import React from "react";
import "../css/ThreeColumns.css";

import { motion } from "framer-motion";

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.3, // controla el tiempo entre columnas
    },
  },
};

const columnVariants = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

const ThreeColumns = ({ col1, col2, col3 }) => {
  return (
    <motion.div
      className="three-columns"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      <motion.div className="column" variants={columnVariants}>
        {col1}
      </motion.div>

      <motion.div className="column" variants={columnVariants}>
        {col2}
      </motion.div>

      <motion.div className="column" variants={columnVariants}>
        {col3}
      </motion.div>
    </motion.div>
  );
};

export default ThreeColumns;
